var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroku(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.276123 0.782227H100.276V100.782H0.276123V0.782227Z",
    fill: "#6762A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9761 79.5782V48.0822C56.9761 48.0822 59.0241 40.5462 31.7401 51.1662C31.6921 51.3022 31.6921 22.0382 31.6921 22.0382L40.6081 21.9822V40.7302C40.6081 40.7302 65.5681 30.8982 65.5681 48.1862V79.5782H56.9761ZM62.0561 33.3302H52.6001C56.0041 29.1702 59.0841 22.0382 59.0841 22.0382H68.8601C68.8641 22.0382 67.1881 26.6862 62.0561 33.3302ZM31.8521 79.5262V61.5902L40.8201 70.5582L31.8521 79.5262Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroku);
export default __webpack_public_path__ + "static/media/heroku.a0b6f27363eda11ff624fe18a506569b.svg";
export { ForwardRef as ReactComponent };